export enum TranslationsKeys {
    ALL = 'All',
    YOURS = 'Yours',
    DELETE = 'DELETE',
    SEARCH = 'spotiqListPage.input.placeHolder',
    DEFAULT_PREFERENCES = 'spotiqListPage.button.defaultPreferences',
    NAME = 'spotiqListPage.captions.name',
    STATUS = 'spotiqListPage.captions.status',
    EXPIRES_IN = 'spotiqListPage.captions.expiresIn',
    LAST_ANALYZED = 'spotiqListPage.captions.lastAnalyzed',
    TRIGGERED_BY = 'spotiqListPage.captions.triggeredBy',
    NO_DATA_TITLE = 'spotiqListPage.noData.title',
    NO_DATA_DESCRIPTION = 'spotiqListPage.noData.description',
    SPOTIQ_HEADER_EXPIRYTIME = 'spotIQ.insights.header.expiryTime',
    SPOTIQ_HEADER_EXPIRES_IN = 'spotIQ.insights.header.expireIn',
    LAST_RUN = 'metadataListPage.captions.A3_WATCH_MGMT_LAST_RUN',
    NO_INSIGHTS = 'NO_INSIGHTS',
    NO_INSIGHTS_STATE = 'NO_INSIGHTS_STATE',
    EXPIRY_NEVER = 'spotiqListPage.expiryTime.never',
    SAVE = 'SAVE',
    CUSTOMIZE_ANALYSIS = 'a3.CUSTOMIZE_ANALYSIS',
    CUSTOMIZE_AND_RUN_ANALYSIS = 'spotIqList.rowMenu.customizeAndRunAnalysis',
    SCHEDULE_JOBS = 'spotIQ.insights.header.scheduleJobs',
    MODIFY_SCHEDULE = 'spotIqList.rowMenu.modifySchedule',
    PAUSE_SCHEDULE = 'spotIqList.rowMenu.pauseSchedule',
    RESUME_SCHEDULE = 'spotIqList.rowMenu.resumeSchedule',
    SCHEDULE_ANALYSIS = 'spotIqList.rowMenu.scheduleAnalysis',
    JOB_SCHEDULE = 'spotIqList.rowMenu.analysisRuns',
    DELETE_PLURAL = 'alert.dataDeletionAlertMessages.withoutContent.plural',
    DELETE_SINGULAR = 'alert.dataDeletionAlertMessages.withoutContent.singular',
    CONFIRM_DELETE = 'CONFIRM_DELETE',
    INSIGHTS = 'DataExplorerVisibleDependents.INSIGHT_ANSWER_BOOK',
    SCHEDULE = 'schedule',
    SCHEDULE_HOURLY = 'scheduler.intervals.HOURLY',
    SCHEDULE_DAILY = 'scheduler.intervals.DAILY',
    SCHEDULE_WEEKLY = 'scheduler.intervals.WEEKLY',
    SCHEDULE_MONTHLY = 'scheduler.intervals.MONTHLY',
    SCHEDULE_NONE = 'None',
    DAY = 'day',
    DAYS_COUNT = 'DAYS_COUNT',
    HOURS_COUNT = 'HOURS_COUNT',
    MINUTES_COUNT = 'MINUTES_COUNT',
    EXPIRED = 'jobRun.status.resultExpired',
    ANALYSIS_FOR = 'a3.visualizationAnalysisTitle',
    COMPLETED = 'jobRun.status.completed',
    FAILED = 'jobRun.status.failed',
    SCHEDULED = 'jobRun.status.scheduled',
    PAUSED = 'jobRun.status.paused',
}

export enum TabType {
    YOURS = 'Yours',
    ALL = 'All',
}
